import { UserCellSkeleton } from "@/components/ui/layout/table/userCell"
import { Skeleton } from "@/components/ui/baseUi/skeleton"
import { cn } from "@/modules/lib/utils"
import backgroundBenchmark from "@images/backgroundBenchmark.png"
import InvitationIcon from "@images/invitationIcon.svg"

export function MemberOfferInvitationLoading({ className }: React.ComponentProps<"div">) {
  return (
    <div className={cn("flex h-[90vh] flex-col gap-6", className)}>
      {/* HEADER */}
      <div
        className="relative flex h-60 rounded-b-3xl bg-neutral-200"
        style={{ marginTop: "-85px", marginRight: "-20px", marginLeft: "-20px" }}
      >
        <div className="mt-2 ml-1 flex h-full w-6/12 flex-col items-center justify-center">
          <div
            className="bg-contain bg-center bg-no-repeat"
            style={{ backgroundImage: `url('${InvitationIcon} ')`, width: "60px", height: "60px" }}
          ></div>
          <>
            <Skeleton className="mt-2 h-[1.9rem] w-[80%] rounded-xl" />
            <Skeleton className="mt-2 h-[0.9rem] w-[40%] rounded-xl" />
            <UserCellSkeleton subtitle={true} className="flex" />
          </>
        </div>
        <div
          className="h-full w-6/12 bg-cover bg-right bg-no-repeat"
          style={{
            background: `url('${backgroundBenchmark}')`,
            clipPath: "polygon(43% 0, 100% 0, 100% 100%, 0% 100%)",
            WebkitClipPath: "polygon(43% 0, 100% 0, 100% 100%, 0% 100%)",
          }}
        ></div>
      </div>
      {/* CONTENT */}
      <Skeleton className="my-6 flex w-full grow rounded-xl" />
    </div>
  )
}
